"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageAudio = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dsWeb = require("@olxbr/ds-web");
var _play = require("./icons/play");
var _pause = require("./icons/pause");
var _dsIcons = require("@olxbr/ds-icons");
var _propTypes = require("prop-types");
var _StatusIcon = require("../../containers/StatusIcon");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var MessageAudio = exports.MessageAudio = function MessageAudio(_ref) {
  var time = _ref.time,
    text = _ref.text,
    isMine = _ref.isMine,
    isAdview = _ref.isAdview,
    status = _ref.status;
  var audioRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPlaying = _useState2[0],
    setIsPlaying = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    duration = _useState4[0],
    setDuration = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currentTime = _useState6[0],
    setCurrentTime = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    downloadError = _useState8[0],
    setDownloadError = _useState8[1];
  var _useState9 = (0, _react.useState)(true),
    _useState10 = _slicedToArray(_useState9, 2),
    loading = _useState10[0],
    setLoading = _useState10[1];
  var Wrapper = isMine ? _style.SentWrapper : _style.ReceivedWrapper;
  (0, _react.useEffect)(function () {
    var _audioRef$current$dur3, _audioRef$current4;
    audioRef.current.addEventListener('loadedmetadata', function () {
      var _audioRef$current$dur, _audioRef$current;
      setDuration((_audioRef$current$dur = (_audioRef$current = audioRef.current) === null || _audioRef$current === void 0 ? void 0 : _audioRef$current.duration) !== null && _audioRef$current$dur !== void 0 ? _audioRef$current$dur : 0);
      setLoading(false);
    });
    audioRef.current.addEventListener('durationchange', function () {
      var _audioRef$current$dur2, _audioRef$current2;
      setDuration((_audioRef$current$dur2 = (_audioRef$current2 = audioRef.current) === null || _audioRef$current2 === void 0 ? void 0 : _audioRef$current2.duration) !== null && _audioRef$current$dur2 !== void 0 ? _audioRef$current$dur2 : 0);
    });
    audioRef.current.addEventListener('timeupdate', function () {
      var _audioRef$current$cur, _audioRef$current3;
      setCurrentTime((_audioRef$current$cur = (_audioRef$current3 = audioRef.current) === null || _audioRef$current3 === void 0 ? void 0 : _audioRef$current3.currentTime) !== null && _audioRef$current$cur !== void 0 ? _audioRef$current$cur : 0);
    });
    audioRef.current.addEventListener('ended', function () {
      setIsPlaying(false);
    });
    audioRef.current.addEventListener('pause', function () {
      setIsPlaying(false);
    });
    audioRef.current.addEventListener('play', function () {
      setIsPlaying(true);
    });
    setDuration((_audioRef$current$dur3 = (_audioRef$current4 = audioRef.current) === null || _audioRef$current4 === void 0 ? void 0 : _audioRef$current4.duration) !== null && _audioRef$current$dur3 !== void 0 ? _audioRef$current$dur3 : 0);
  }, []);
  var toggleAudio = function toggleAudio() {
    if (!isPlaying) {
      var _audioRef$current5;
      document.querySelectorAll('audio').forEach(function (element) {
        element === null || element === void 0 || element.pause();
      });
      (_audioRef$current5 = audioRef.current) === null || _audioRef$current5 === void 0 || _audioRef$current5.play();
      setIsPlaying(true);
    }
    if (isPlaying) {
      var _audioRef$current6;
      (_audioRef$current6 = audioRef.current) === null || _audioRef$current6 === void 0 || _audioRef$current6.pause();
      setIsPlaying(false);
    }
  };
  var recreateAudio = function recreateAudio() {
    var _audioRef$current7;
    (_audioRef$current7 = audioRef.current) === null || _audioRef$current7 === void 0 || _audioRef$current7.load();
  };
  var getDurationComponent = function getDurationComponent() {
    if (downloadError) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
    }
    if (!isPlaying) {
      var durationMinutes = ('0' + Math.floor(duration / 60)).slice(-2);
      var durationSeconds = ('0' + Math.floor(duration - durationMinutes * 60)).slice(-2);
      if (isNaN(durationMinutes) || duration === 0) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
          width: "32px",
          height: "14px"
        });
      }
      return "".concat(durationMinutes, ":").concat(durationSeconds);
    }
    if (isPlaying) {
      var currentTimeMinutes = ('0' + Math.floor(currentTime / 60)).slice(-2);
      var currentTimeSeconds = ('0' + Math.floor(currentTime - currentTimeMinutes * 60)).slice(-2);
      return "".concat(currentTimeMinutes, ":").concat(currentTimeSeconds);
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  };
  var getIconComponent = function getIconComponent() {
    if (loading) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.PlayPauseWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Spinner, {
          size: "extra-small",
          "aria-label": "Carregando \xE1udio",
          color: isMine ? '--color-secondary-130' : '--color-neutral-130'
        })
      });
    }
    if (downloadError) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.PlayPauseWrapper, {
        onClick: recreateAudio,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Download, {})
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.PlayPauseWrapper, {
      onClick: toggleAudio,
      children: isPlaying ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_pause.Pause, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_play.Play, {})
    });
  };
  var onError = function onError() {
    setDownloadError(true);
    setLoading(false);
  };
  var progressBarWidth = currentTime === 0 ? 100 : currentTime / duration * 100;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("audio", {
      ref: audioRef,
      src: "".concat(text),
      preload: "metadata",
      onError: onError
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.PlayerWrapper, {
      children: [getIconComponent(), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ProgressBarWrapper, {
        isAdview: isAdview,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ProgressBar, {
          isMine: isMine,
          style: {
            width: "".concat(progressBarWidth, "%")
          }
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.TimeWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.DurationTimeArea, {
        children: getDurationComponent()
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.TimeArea, {
          children: time
        }), isMine && /*#__PURE__*/(0, _jsxRuntime.jsx)(_StatusIcon.StatusIcon, {
          status: status
        })]
      })]
    })]
  });
};
MessageAudio.propTypes = {
  time: _propTypes.string.isRequired,
  text: _propTypes.string.isRequired,
  isMine: _propTypes.bool.isRequired,
  isAdview: _propTypes.bool.isRequired,
  status: _propTypes.string.isRequired
};